import { create } from "zustand";
import { EQUIPEMENT_PAR_TYPE, LIST_EQUIP } from "../../Utils/constant";
import { find, getAll } from "../../services/service";
export const useStoreEquipement = create((set) => ({
  loading: false,
  data: [],
  list: [],
  count: 1,
  equipement: async (param) => {
    set({
      loading: true,
      data: [],
      count: 1,
    });

    try {
      const equipements = await getAll(LIST_EQUIP, param, "");
      set({
        loading: false,
        data: equipements.data,
        count: equipements.data.totalPages,
      });
    } catch (error) {
      set({
        loading: true,
        data: [],
        count: 1,
      });
    }
  },
  listEquipement: async (param) => {
    set({
      loading: true,
      list: [],
    });

    try {
      const equipements = await find(`${EQUIPEMENT_PAR_TYPE}?typeClient=${param}`);
      set({
        loading: false,
        list: equipements?.data?.donnee,
      });
    } catch (error) {
      set({
        loading: true,
        list: [],
      });
    }
  },
}));
